import type { ProgramLandingPageChallengerProps as BaseProgramLandingPageChallengerProps } from '~/features/experiments/ab_plp_redesign_2025/components/program-landing-page';
import { ProgramLandingPageChallenger as BaseProgramLandingPageChallenger } from '~/features/experiments/ab_plp_redesign_2025/components/program-landing-page';

import { OutcomesSection, StaticOutcomesSubsectionProps } from './outcomes-section';
import { ProjectsSubsection, StaticProjectsSubsectionProps } from './projects-subsection';

export type ProjectFirstProgramLandingPageProps = BaseProgramLandingPageChallengerProps & {
  staticProjectsSubsectionProps: StaticProjectsSubsectionProps;
  staticOutcomesSubsectionProps: StaticOutcomesSubsectionProps;
};

export function ProjectFirstProgramLandingPage({
  staticProjectsSubsectionProps,
  staticOutcomesSubsectionProps,
  ...props
}: ProjectFirstProgramLandingPageProps) {
  // Outcomes are resolved in getStaticProps (see transformStaticOutcomesSubsectionProps)
  // so a program without outcomes data falls through to the base SalariesSection
  // instead of leaving an empty slot behind a section divider.
  const outcomesSectionSlot = staticOutcomesSubsectionProps && <OutcomesSection {...staticOutcomesSubsectionProps} />;

  return (
    <BaseProgramLandingPageChallenger
      {...props}
      outcomesSectionSlot={outcomesSectionSlot ?? null}
      projectsSlot={
        staticProjectsSubsectionProps && (
          <ProjectsSubsection
            {...staticProjectsSubsectionProps}
            staticDownloadSyllabusButtonProps={props.staticDownloadSyllabusButtonProps}
          />
        )
      }
    />
  );
}
